import { useMutation } from '@apollo/client';
import { useToast } from '@synoptic/ui-kit/toast/toast-provider.tsx';
import { gql } from '@/__generated__/index.ts';
import {
  STREAM_POSTS_PAGE_SIZE,
  StreamPostsQuery,
} from '@/routes/_app.p.streams_.$id._index/use-stream-posts';

const SetCustomTargets = gql(`
  mutation SetCustomTargets($id: ID!, $input: SetStreamCustomTargetsInput!) {
    setStreamCustomTargets(id: $id, input: $input)
  }
`);

export const useSetCustomTargets = (id: string, refetchPosts?: boolean) => {
  const toast = useToast();

  const [setCustomTargetsMutation, result] = useMutation(SetCustomTargets, {
    onCompleted: () => {
      toast.success({
        title: 'Custom targets successfully submitted',
      });
    },
    onError: (e) => {
      toast.error({
        title: 'Failed to submit custom targets',
        subTitle: e.message,
      });
    },

    update: (cache, { data }) => {
      if (data?.setStreamCustomTargets) {
        cache.modify({
          id: cache.identify({ id, __typename: 'Stream' }),
          fields: {
            customTargets: () => data.setStreamCustomTargets,
          },
        });
      }
    },

    refetchQueries: refetchPosts
      ? [
          {
            query: StreamPostsQuery,
            variables: { id, limit: STREAM_POSTS_PAGE_SIZE, nextToken: null },
          },
        ]
      : [],
  });

  const setCustomTargets = (customTargets: string[]) => {
    return setCustomTargetsMutation({
      variables: {
        id,
        input: { customTargets },
      },
    });
  };

  return [setCustomTargets, result] as const;
};
